import { inject, Injectable, signal, Type } from '@angular/core';
import { BaseObjOutputDialogInterface } from '@shared/library/configs/interfaces/base-obj-data-output-dialog-interface';
import { AlertConfirmBaseInterface } from '@shared/library/configs/interfaces/alert-confirm-interface';
import { CloseDialogModalEnum } from '@shared/library/configs/enums/close-dialog-modal-enum';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class BaseDialogService {
  public refDialogModal = signal<MatDialogRef<any> | undefined>( undefined );
  public baseData = signal<AlertConfirmBaseInterface | undefined>( undefined );

  readonly dialog: MatDialog = inject( MatDialog );

  constructor() {
    this.getBaseData();
  }

  private getBaseData() {
    this.baseData.set( 
      {
        title: '¿Desea confirmar la transacción?',
        label: ''
      }
    )
  }

  public showDialog<T>(width: string, height: string, component: Type<T>, disableClose: boolean, data?: any, fnCancel?: Function, fnOk?: Function, autoFocus: boolean = true): MatDialogRef<T> {
    const dialogRef = this.dialog.open( component, { 
      width,
      height,
      maxWidth: '90vw',  
      maxHeight: '99vh', 
      panelClass: 'base-dialog',
      disableClose,
      autoFocus,
      data
    });

    this.refDialogModal.set( dialogRef );
    this.closeDialog( fnCancel, fnOk );

    return dialogRef;
  }

  private closeDialog(fnCancel?: Function, fnOk?: Function) {
    this.refDialogModal()?.afterClosed().subscribe((res: BaseObjOutputDialogInterface | undefined) => {
      if(res === undefined || res.message === CloseDialogModalEnum.CANCEL){
        if(fnCancel) fnCancel( res );
        return;
      } 

      if(fnOk) fnOk( res );
    });
  }
}